import { LocalizationModel } from '@shared/core';
import { IBaseResponseModel, IBaseValueModel } from './base.model';

export interface IAbonementModel {
  active: boolean;
  isDeleted?: boolean;
  is_deleted?: boolean;
  currentUsesCount: number;
  price: string;
  uuid: IBaseValueModel;
  name: LocalizationModel;
  zones: string[];
  duration: IAbonementDurationModel;
  startType: AbonementStartType;
  type: IAbonementTypeEnum;
  is_single_zone?: boolean;
  isSingleZone?: boolean;
}

export interface IAbonementGrantCreatePayload {
  start: string;
  abonementUuid: IBaseValueModel;
  tip: string;
  useruuid: IBaseValueModel;
  zones: string[];
}

export interface IAbonementDurationModel {
  years: number;
  months: number;
  days: number;
}

export enum AbonementStartType {
  START_TYPE_UNSPECIFIED = 0,
  START_TYPE_FROMTOMORROW = 1,
  START_TYPE_FROMTODAY = 2,
  START_TYPE_FROMYESTERDAY = 3,
}

export interface IAbonementFilterModel {
  active: boolean;
}
export interface IAbonementGrantsFilterModel {
  status?: AbonementGrantStatus;
  abonements_uuids: string[];
  limit?: number;
  offset?: number;
  vrps?: string[];
}

export interface IAbonementGrantsResponseModel extends IBaseResponseModel {
  grants: IAbonementGrantsModel[];
}

export interface IAbonementGrantsModel {
  uuid: IBaseValueModel;
  start: string;
  end: string;
  abonementUuid: IBaseValueModel;
  createdAt: string;
  vrp: string;
  abonement: IAbonementModel;
  price?: string;
  zones: string[];
  isDeleted?: boolean;
}

export enum AbonementGrantStatus {
  STATUS_UNSPECIFIED = 0,
  STATUS_FUTURE = 1,
  STATUS_PAST = 2,
  STATUS_CURRENT = 3,
  STATUS_ALL = 4,
}

export type AbonementGrantStatusTranslation = {
  [K in string]: AbonementGrantStatus;
};
export const ABONEMENT_GRANT_STATUS_TRANSLATIONS: AbonementGrantStatusTranslation = {
  'Не указан': 0,
  Будущий: 1,
  Прошедший: 2,
  Активный: 3,
  Все: 4,
};

export enum IAbonementTypeEnum {
  FIZ = 'TYPE_FIZ',
  UR = 'TYPE_UR',
}

export const IAbonementTypeLabel = {
  [IAbonementTypeEnum.FIZ]: 'ADMIN_DASHBOARD_ABONEMENTS_TYPE_FIZ',
  [IAbonementTypeEnum.UR]: 'ADMIN_DASHBOARD_ABONEMENTS_TYPE_UR',
};
